import { render, staticRenderFns } from "./Unprocessed.vue?vue&type=template&id=e65167a6&scoped=true&"
import script from "./Unprocessed.vue?vue&type=script&lang=js&"
export * from "./Unprocessed.vue?vue&type=script&lang=js&"
import style0 from "./Unprocessed.vue?vue&type=style&index=0&id=e65167a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65167a6",
  null
  
)

export default component.exports